import { AccessIcon } from "./AccessIcon";

export function AccessBranding({ small = false }: { small?: boolean }) {
  return (
    <div data-embed-hide className="text-left flex items-center gap-3">
      <AccessIcon
        size={small ? 32 : 56}
        className="text-[var(--color-gold)] shrink-0"
        title="Lagamobilen Access"
      />
      <div>
        <div className={`font-display font-light text-white tracking-wider ${small ? "text-xl" : "text-3xl md:text-4xl"}`}>LAGAMOBILEN</div>
        <div className={`font-display font-semibold text-[var(--color-gold)] tracking-[0.18em] leading-none ${small ? "text-3xl" : "text-6xl md:text-7xl"}`}>ACCESS</div>
      </div>
    </div>
  );
}
